import React, { Component } from 'react';

import {
  Paper, FormControl, TextField, Button, InputLabel, Select, MenuItem, Grid,
} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';

import DeleteIcon from '@material-ui/icons/Delete';
import CloseIcon from '@material-ui/icons/Close';

import {
  TYPE_MAPPINGS, TASK_TYPES, TASK_TYPE_AND_MODEL_MAPPINGS, TOOLS,
} from '../utils/constants';
import MultipleSelect from './MultipleSelect';
import MultipleText from './MultipleText';

class TaskForm extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  getInitialState() {
    const { day, task, plan } = this.props;
    return {
      template: '',
      taskType: '',
      type: '',
      name: `${plan && plan.name}_day_${day}_${task}`,
      title: '',
      time: '',
      precedings: [],
      ids: [],
      day,
      task,
      plan: plan && plan._id,
      types: Object.keys(TYPE_MAPPINGS),
      refCollection: '',
    };
  }

  componentDidMount() {
    const { taskData } = this.props;
    if (taskData) {
      this.setState({
        _id: taskData._id,
        taskType: taskData.taskType,
        type: taskData.type,
        name: taskData.name,
        title: taskData.title,
        time: taskData.time,
        precedings: taskData.precedings && [...taskData.precedings],
        ids: taskData.ids,
        day: taskData.day,
        task: taskData.task,
        plan: taskData.plan,
        refCollection: taskData.refCollection,
      });
    }
  }

    // eslint-disable-next-line consistent-return
    getIdsData = (type) => {
      const {
        practiceExercises, quizes, assessments, learnExercises, videoTypeExercises, videoUrlTypeExercises,
      } = this.props;
      const taskType = TYPE_MAPPINGS[type];
      switch (taskType) {
        case TASK_TYPES.PRACTICE: return practiceExercises;
        case TASK_TYPES.ASSESSMENT: return assessments;
        case TASK_TYPES.LEARN: return learnExercises;
        case TASK_TYPES.QUIZ: return quizes;
        case TASK_TYPES.URL: return TOOLS;
        case TASK_TYPES.VIDEO: return videoTypeExercises;
        case TASK_TYPES.VIDEO_URL: return videoUrlTypeExercises;
        default:
      }
    }

    chooseTemplate = (event) => {
      const template = event.target.value;
      if (template) {
        this.setState({
          template,
          title: template.title,
          time: template.time,
          precedings: template.precedings,
          name: template.name,
          ids: template.ids,
          type: template.type,
          taskType: template.taskType,
          refCollection: template.refCollection,
        });
      } else {
        this.setState(this.getInitialState());
      }
    };

    chooseTaskType = (event) => {
      this.setState({
        type: event.target.value,
        taskType: TYPE_MAPPINGS[event.target.value],
        refCollection: TASK_TYPE_AND_MODEL_MAPPINGS[TYPE_MAPPINGS[event.target.value]],
      });
    };

    addPreceding=() => {
      this.setState((prevState) => { return { precedings: [...prevState.precedings, ''], ids: this.ids }; });
    };

    changedPreceding=(e, index) => {
      e.persist();
      this.setState((prevState) => {
        // eslint-disable-next-line no-param-reassign
        prevState.precedings[index] = e.target.value;
        return { precedings: prevState.precedings, ids: this.ids };
      });
    }

    removePreceding=(index) => {
      this.setState((prevState) => {
        const precedings = [...prevState.precedings];
        precedings.splice(index, 1);
        return { ...prevState, precedings };
      });
    }

    formupdated=(e) => {
      // eslint-disable-next-line react/no-access-state-in-setstate
      this.setState({ ...this.state, [e.target.name]: e.target.value, ids: this.ids });
    }

    // handleChange = (event) => {
    //     this.setState({ user: event.target.value });
    // };

    // formSubmitted = (e) => {
    //     // e.preventDefault();
    //     const data = { ...this.state, ids: this.learnExercises};
    //     // alert(JSON.stringify(data));
    //     this.props.addTask(data)
    //         .then(() => alert(JSON.stringify(data)));
    // }

    deleteTask = () => {
      // const key = `${this.state.day}_${this.state.task}`;
      this.props.deleteTask(this.state.day, this.state.task, this.state._id);
    }

    setExercisesIds = (ids) => {
      this.ids = ids;
      this.passDataToParent();
    }

    passDataToParent() {
      const { collectData } = this.props;
      const data = {
        _id: this.state._id,
        name: this.state.name,
        title: this.state.title,
        time: this.state.time,
        precedings: this.state.precedings,
        ids: this.ids,
        day: this.state.day,
        task: this.state.task,
        taskType: this.state.taskType,
        type: this.state.type,
        plan: this.state.plan,
        refCollection: this.state.refCollection,
      };
      collectData(data);
    }

    render() {
      const {
        taskTemplates, task, showDelete, day,
      } = this.props;
      const templates = this.state.type ? taskTemplates && taskTemplates.filter((template) => {
        return template.type === this.state.type;
      }) : taskTemplates;
      const idsData = this.getIdsData(this.state.type);
      this.passDataToParent();
      // if (save) this.formSubmitted();

      return (
        <div style={{ display: 'flex' }}>
          <Paper style={{ width: '100%', padding: 10, margin: 20 }}>
            {
                        showDelete
                          ? (
                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                              <IconButton aria-label="delete" onClick={this.deleteTask}>
                                <DeleteIcon />
                              </IconButton>
                            </div>
                          ) : null
                    }
            <div>
              <h3>
                Day:
                {' '}
                {day}
                {' '}
                Task:
                {' '}
                {task}
              </h3>
            </div>
            {/* <form className="form" onSubmit={this.formSubmitted} autoComplete="off"> */}
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <FormControl style={{ width: 120, margin: 10 }}>
                <InputLabel id="simple-select-tasktype-label">Task Type</InputLabel>
                <Select
                  labelId="simple-select-tasktype-label"
                  id="simple-select-tasktype"
                  value={this.state.type}
                  onChange={this.chooseTaskType}
                  style={{ textAlign: 'left' }}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {
                        // eslint-disable-next-line react/no-array-index-key
                        this.state.types && this.state.types.map((type, index) => { return (<MenuItem key={index} value={type}>{type}</MenuItem>); })
                    }
                </Select>
              </FormControl>
              <FormControl style={{ width: 120, margin: 10 }}>
                <InputLabel id="simple-select-plan-label">Templates</InputLabel>
                <Select
                  labelId="simple-select-plan-label"
                  id="simple-select-plan"
                  value={this.state.template}
                  onChange={this.chooseTemplate}
                  style={{ textAlign: 'left' }}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {
                    templates && templates.map((template) => { return (<MenuItem key={template._id} value={template}>{template.name}</MenuItem>); })
                    }
                </Select>
              </FormControl>
              {
                            idsData
                              ? (
                                <FormControl style={{ minWidth: 200, margin: 10 }}>
                                  <MultipleSelect
                                    selectedData={this.state.ids}
                                    data={idsData}
                                    callBack={this.setExercisesIds}
                                    name={`${this.state.type} Exercises`}
                                  />
                                </FormControl>
                              )
                              : (
                                <FormControl style={{ minWidth: 200, margin: 10 }}>
                                  <MultipleText selectedData={this.state.ids} callBack={this.setExercisesIds} name={`${this.state.type} Exercises`} />
                                </FormControl>
                              )
                        }
              <FormControl style={{ width: 120, margin: 10 }}>
                <TextField name="name" label="Name" value={this.state.name} onChange={(e) => { this.formupdated(e); }} />
              </FormControl>
              <FormControl style={{ width: 120, margin: 10 }}>
                <TextField name="title" label="Title" value={this.state.title} onChange={(e) => { this.formupdated(e); }} />
              </FormControl>
              <FormControl style={{ width: 100, margin: 10 }}>
                <TextField name="time" label="Time" value={this.state.time} onChange={(e) => { this.formupdated(e); }} />
              </FormControl>
              {/* <FormControl style={{marginTop: '50px'}}>
                            <Button variant="contained" type="submit" color="primary">Add Task</Button>
                        </FormControl> */}
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              {this.state.precedings && this.state.precedings.map((preceding, index) => {
                return (
                  // eslint-disable-next-line react/no-array-index-key
                  <FormControl key={index} style={{ width: 120, margin: 10 }}>
                    <Grid container justify="flex-start">
                      <IconButton onClick={() => { return this.removePreceding(index); }} size="small">
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </Grid>
                    <TextField
                      name={`preceding${index}`}
                      label={`Preceding ${index}`}
                      value={this.state.precedings[index]}
                      onChange={(e) => { this.changedPreceding(e, index); }}
                    />
                  </FormControl>
                );
              })}
              <FormControl style={{ margin: 10, paddingTop: 10 }}>
                <Button onClick={this.addPreceding}>Add Precedings</Button>
              </FormControl>
              <br />
            </div>
            {/* </form> */}
          </Paper>
        </div>
      );
    }
}

export default TaskForm;
